/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  OrderingBillingExportsCreatePublicData,
  OrderingBillingExportsCreatePublicFormatsEnum,
  OrderingBillingExportsCreatePublicTypeEnum1,
  OrderingBillingExportsCreatePublicTypeEnum2,
  OrderingBillingExportsDownloadPublicData,
  OrderingBillingExportsListPublicData,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class BillingExports<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
 * @description Allow brands to request a bulk billing export
 *
 * @tags Ankorstore_Ordering
 * @name OrderingBillingExportsCreatePublic
 * @summary Create Billing Export
 * @request POST:/api/v1/ordering/billing-exports
 * @secure
 * @response `200` `OrderingBillingExportsCreatePublicData` Single Billing Export
 * @response `400` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Bad request
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` [Forbidden](https://jsonapi.org/format/#crud-creating-responses-403)
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided are invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` [Server Error](https://jsonapi.org/format/#errors)
 */
  orderingBillingExportsCreatePublic = (
    data: {
      data: {
        type?: OrderingBillingExportsCreatePublicTypeEnum1;
        attributes: {
          exports: {
            type: OrderingBillingExportsCreatePublicTypeEnum2;
            formats: OrderingBillingExportsCreatePublicFormatsEnum[];
          }[];
          /** @format date */
          from: string;
          /** @format date */
          to: string;
        };
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      OrderingBillingExportsCreatePublicData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/v1/ordering/billing-exports`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description Returns a list of billing exports for the authenticated brand
 *
 * @tags Ankorstore_Ordering
 * @name OrderingBillingExportsListPublic
 * @summary List Billing Exports
 * @request GET:/api/v1/ordering/billing-exports
 * @secure
 * @response `200` `OrderingBillingExportsListPublicData` Collection of billing exports
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` [Forbidden](https://jsonapi.org/format/#crud-creating-responses-403)
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  orderingBillingExportsListPublic = (params: RequestParams = {}) =>
    this.request<
      OrderingBillingExportsListPublicData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/v1/ordering/billing-exports`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
 * @description Downloads a completed billing export
 *
 * @tags Ankorstore_Ordering
 * @name OrderingBillingExportsDownloadPublic
 * @summary Download a Billing Export
 * @request GET:/api/v1/ordering/billing-exports/{billing_export}/-actions/download
 * @secure
 * @response `200` `OrderingBillingExportsDownloadPublicData` Returns billing export file content in body
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` [Forbidden](https://jsonapi.org/format/#crud-creating-responses-403)
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` [Not found](https://jsonapi.org/format/#fetching-resources-responses-404)
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` [Server Error](https://jsonapi.org/format/#errors)
 */
  orderingBillingExportsDownloadPublic = (billingExport: string, params: RequestParams = {}) =>
    this.request<
      OrderingBillingExportsDownloadPublicData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/v1/ordering/billing-exports/${billingExport}/-actions/download`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
